import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { environmentConfig } from 'environmentConfig';
import packageJson from '../../package.json';
const TEAM_TAG = 'oneid';
export const initializeDatadog = () => {
    try {
        const verboseConsoleLogEnvs = ['local', 'dev-dit-amr', 'dev-fit-amr'];
        const forwardConsoleLogs = verboseConsoleLogEnvs.includes(environmentConfig.env) ? 'all' : ['error'];
        datadogLogs.init({
            clientToken: 'pub8f403f58718af66d8e6af5822b2eee10',
            site: 'datadoghq.com',
            service: 'identity-my-account-app',
            env: environmentConfig.env,
            version: packageJson.version,
            sessionSampleRate: 100,
            forwardErrorsToLogs: true,
            forwardConsoleLogs,
            beforeSend: (event) => {
                event.ddtags = [event.ddtags, `team:${TEAM_TAG}`].filter(Boolean).join(',');
                return true;
            }
        });
        datadogRum.init({
            applicationId: 'aab377d7-957d-47e1-b26d-4ef32f4c2403',
            clientToken: 'pubd2aba653fa45a2a210ff957a77d6aa9c',
            site: 'datadoghq.com',
            service: 'identity-my-account-app',
            env: environmentConfig.env,
            version: packageJson.version,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask-user-input',
            trackViewsManually: true,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            allowedTracingUrls: [
                { match: /https:\/\/.*\.resmed\.com/, propagatorTypes: ['tracecontext'] },
                { match: /https:\/\/.*\.dht\.live/, propagatorTypes: ['tracecontext'] },
                { match: /http:\/\/localhost/, propagatorTypes: ['tracecontext'] }
            ],
            beforeSend: (event) => {
                const mutableEvent = event;
                mutableEvent.ddtags = [mutableEvent.ddtags, `team:${TEAM_TAG}`].filter(Boolean).join(',');
                return true;
            }
        });
        datadogRum.setGlobalContextProperty('team', TEAM_TAG);
        datadogLogs.setGlobalContextProperty('team', TEAM_TAG);
        datadogRum.startSessionReplayRecording();
    }
    catch (error) {
        console.error('[Datadog] Failed to initialize RUM:', error);
    }
};
